import { useState, useMemo, useCallback } from 'react';

/**
 * Custom hook for managing stage selection
 * @returns State and functions related to stage selection
 */
export const useStageSelection = () => {
    // Set of selected stage IDs
    const [selectedStages, setSelectedStages] = useState<Set<string>>(new Set());

    // Memoized count of selected stages
    const selectedCount = useMemo(() => selectedStages.size, [selectedStages]);

    // Toggle selection of a stage
    const toggleStageSelection = useCallback((stageId: string) => {
        setSelectedStages(prevSelected => {
            const newSelected = new Set(prevSelected);
            if (newSelected.has(stageId)) {
                newSelected.delete(stageId);
            } else {
                newSelected.add(stageId);
            }
            return newSelected;
        });
    }, []);

    // Clear all selections
    const clearSelection = useCallback(() => {
        setSelectedStages(new Set());
    }, []);

    return {
        selectedStages,
        selectedCount,
        toggleStageSelection,
        clearSelection
    };
}; 